import { PagePlaceholder } from '../_PagePlaceholder';
export function FeesPage() {
  return <PagePlaceholder title="Fees & Payments" />;
}
